<template>
  <div class="loading-spinner" v-if="show">
    <div class="spinner-grow text-danger" role="status"></div>
    <p class="mb-0 mt-2 text-light" v-if="text">{{text}}</p>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "spinner",
  props: ["show", "text"],
  watch: {
    show: {
      handler() {
        if (this.show) {
          $("body").addClass("overflow-hidden");
        } else {
          $("body").removeClass("overflow-hidden");
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.loading-spinner {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background-color: #000000d0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
</style>